module.exports = __webpack_public_path__ + "img/shopify.f4a74103.svg";